/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharestatusconfirmed2Inputs */

const en_sharestatusconfirmed2 = /** @type {(inputs: Sharestatusconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`credited`)
};

const de_sharestatusconfirmed2 = /** @type {(inputs: Sharestatusconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gutgeschrieben`)
};

/**
* | output |
* | --- |
* | "credited" |
*
* @param {Sharestatusconfirmed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharestatusconfirmed2 = /** @type {((inputs?: Sharestatusconfirmed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharestatusconfirmed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharestatusconfirmed2(inputs)
	return de_sharestatusconfirmed2(inputs)
});
export { sharestatusconfirmed2 as "shareStatusConfirmed" }